/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateMasterDatasCommand } from '../models/CreateMasterDatasCommand';
import type { CreateSublimitSubTypeCommand } from '../models/CreateSublimitSubTypeCommand';
import type { DeleteMasterDatasCommand } from '../models/DeleteMasterDatasCommand';
import type { EditMasterDatasCommand } from '../models/EditMasterDatasCommand';
import type { EditSublimitSubTypeCommand } from '../models/EditSublimitSubTypeCommand';
import type { MasterDataDtoPaginatedResult } from '../models/MasterDataDtoPaginatedResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MasterDatasService {
    /**
     * @param requestBody
     * @returns string Created
     * @throws ApiError
     */
    public static postApiMasterDatas(
        requestBody?: CreateMasterDatasCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MasterDatas',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns string Created
     * @throws ApiError
     */
    public static patchApiMasterDatas(
        id: string,
        requestBody?: EditMasterDatasCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/MasterDatas/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiMasterDatas(
        id: string,
        requestBody?: DeleteMasterDatasCommand,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/MasterDatas/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param entity
     * @param pageNumber
     * @param pageSize
     * @param search
     * @returns MasterDataDtoPaginatedResult OK
     * @throws ApiError
     */
    public static getApiMasterDatas(
        entity: string,
        pageNumber?: number,
        pageSize?: number,
        search?: string,
    ): CancelablePromise<MasterDataDtoPaginatedResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/MasterDatas/{entity}',
            path: {
                'entity': entity,
            },
            query: {
                'PageNumber': pageNumber,
                'PageSize': pageSize,
                'Search': search,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns string Created
     * @throws ApiError
     */
    public static postApiMasterDatasSublimitSubTypes(
        requestBody?: CreateSublimitSubTypeCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/MasterDatas/SublimitSubTypes',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static patchApiMasterDatasSublimitSubTypes(
        id: string,
        requestBody?: EditSublimitSubTypeCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/MasterDatas/SublimitSubTypes/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiMasterDatasSublimitSubTypes(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/MasterDatas/SublimitSubTypes/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param typeId
     * @param search
     * @returns MasterDataDtoPaginatedResult OK
     * @throws ApiError
     */
    public static getApiMasterDatasSublimitTypesSublimitSubTypes(
        typeId: string,
        search?: string,
    ): CancelablePromise<MasterDataDtoPaginatedResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/MasterDatas/SublimitTypes/{typeId}/SublimitSubTypes',
            path: {
                'typeId': typeId,
            },
            query: {
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
